import { render, staticRenderFns } from "./modifyTraining.vue?vue&type=template&id=4aceee2d&scoped=true"
import script from "./modifyTraining.vue?vue&type=script&lang=js"
export * from "./modifyTraining.vue?vue&type=script&lang=js"
import style0 from "./modifyTraining.vue?vue&type=style&index=0&id=4aceee2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aceee2d",
  null
  
)

export default component.exports